import {useEffect, useRef} from "react";
import {useLocation} from "react-router-dom";

const useWatchUrlParam = (
  key: string,
  callback: (newValue: string | null, oldValue: string | null) => void
) => {
  const location = useLocation();
  const prevValue = useRef<string | null>(null);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const value = params.get(key);

    if (prevValue.current !== value) {
      callback(value, prevValue.current);
      prevValue.current = value;
    }
  }, [location.search, key]);
};

export default useWatchUrlParam;